import defaultSettings from "../../config/defaultSettings";
import { svc_fetchAll, svc_editOne } from "@/services";
import { showServerResponse } from "@/utils/message";

const updateColorWeak = (colorWeak) => {
	const root = document.getElementById("root");

	if (root) {
		root.className = colorWeak ? "colorWeak" : "";
	}
};

const endpointBasePrefix = "settings";

const SettingModel = {
	namespace: "m_Setting",
	state: defaultSettings,
	reducers: {
		changeSetting(state = defaultSettings, { payload }) {
			const { colorWeak, contentWidth } = payload;

			if (state.contentWidth !== contentWidth && window.dispatchEvent) {
				window.dispatchEvent(new Event("resize"));
			}

			updateColorWeak(!!colorWeak);
			return { ...state, ...payload };
		},
	},
	effects: {
		*fetchAll({}, { call }) {
			let setting = yield call(svc_fetchAll, `${endpointBasePrefix}`);

			return setting;
		},
		*fetch({ key }, { call }) {
			let setting = yield call(svc_fetchAll, `${endpointBasePrefix}/${key}`);

			return setting ? true: false;
		},
		*editOne({ payload }, { call }) {
			const response = yield call(
				svc_editOne,
				endpointBasePrefix,
				payload,
				"key",
			);
			return showServerResponse(response);
		},
	},
};
export default SettingModel;
